// extracted by mini-css-extract-plugin
export default {"videoLink":"chat-video_videoLink__V3yHp","videoWrapper":"chat-video_videoWrapper__9XBcP","video":"chat-video_video__KWTsF","videoOverlay":"chat-video_videoOverlay__M3kH7"};